import { Component, OnInit } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {ActivatedRoute, Router} from '@angular/router';
import {PATH_AGRIS_BUSCADOR, PATH_AGRIS_NUEVA_COTIZACION} from '../../../navigation/navigation.module';
import {AgrisService, PermisosService} from '../../../services';
import {CotizacionAgrisViewModel, CotizacionesAgrisFilterViewModel} from '../common/AgrisViewModels';

@Component({
  selector: 'app-home',
  templateUrl: './agris-home-page.component.html',
  styleUrls: ['./agris-home-page.component.scss', '../common/agris-common-styles.scss']
})
export class AgrisHomePageComponent implements OnInit {

  ultimasCotizaciones: CotizacionAgrisViewModel[] = [];
  ASSETS_URL = environment.ASSETS_URL;
  count = 0;


  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private agrisService: AgrisService,
    private permServ: PermisosService,
  ) {
    permServ.verificarAccesoDeURL();
  }

  ngOnInit() {
    const payload: CotizacionesAgrisFilterViewModel = {MisCotizaciones: true, OrderByFechaCreacion: true, PageNumber: 0, PageSize: 5, filter: '', Pendientes: false}
    this.agrisService.searchCotizaciones(payload).subscribe(x => {
      this.ultimasCotizaciones = x;
    }, err => this.agrisService.showSnackbarAPIError());
    this.agrisService.countPendientes().subscribe(x => {
      if (x !== null && x !== undefined) {
        this.count = x;
      }
    }, err => this.agrisService.showSnackbarAPIError());
  }

  onSearch(e: string) {
    this.router.navigate([PATH_AGRIS_BUSCADOR, e]);
  }

  onNuevaCotizacion() {
    this.agrisService.nuevaCotizInsumo = null;
    this.router.navigate([PATH_AGRIS_NUEVA_COTIZACION]);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/agris/agris-home-page/agris-home-page.component.ts